"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-0b4f8186"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "label" };
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const label = (0, vue_3.ref)("");
        const getNode = (0, vue_3.inject)('getNode');
        (0, vue_3.onMounted)(() => {
            const node = getNode();
            const data = node.getData();
            label.value = data.label;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, (0, vue_2.toDisplayString)(label.value), 1));
        };
    }
});
